import React from 'react'
import css from './style.scss'
import {Link} from 'react-router-dom';


export default (props)=>(
  <div className={css.footer}>
    <div className={css.footerContainer}>
      <div className={css.cont}>
        <h3>Ready to start?</h3>
        <Link className={css.joinButton} to="/signup">Join now for free</Link>
        <small>No credit card necessary</small>
      </div>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/home_page/landing/sections/footer.js